var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.994 43.999c-.52 0-1.028-.203-1.411-.586l-5.408-5.417h-9.104c-.553 0-1-.448-1-1s.447-1 1-1h9.52c.266 0 .521.105.708.293l5.7 5.71.002-5.003c0-.552.447-1 1-1h4c1.654 0 3-1.346 3-3v-18c0-1.068-.574-2.062-1.498-2.593-.479-.275-.645-.887-.369-1.366s.885-.643 1.365-.369c1.543.887 2.502 2.545 2.502 4.327v18c0 2.757-2.243 5-5 5h-3v4c0 .812-.485 1.538-1.237 1.849-.249.104-.511.154-.769.154z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.002 37.999c-.258 0-.519-.05-.768-.153-.75-.311-1.234-1.036-1.234-1.848v-3.998h-3c-2.757 0-5-2.243-5-5v-18c0-2.757 2.243-5 5-5h26c2.757 0 5 2.243 5 5v18c0 2.757-2.243 5-5 5h-14.174l-5.412 5.412c-.384.383-.893.587-1.412.587zm-5.002-31.999c-1.654 0-3 1.346-3 3v18c0 1.654 1.346 3 3 3h4c.553 0 1 .448 1 1v4.998l5.705-5.705c.188-.188.441-.293.707-.293h14.588c1.654 0 3-1.346 3-3v-18c0-1.654-1.346-3-3-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21 22c-.553 0-1-.448-1-1v-.77c0-1.453.825-2.775 2.208-3.536.985-.545 1.479-1.669 1.227-2.795-.204-.891-.942-1.63-1.837-1.834-.709-.163-1.421-.031-2.003.369-.578.397-.966 1.02-1.064 1.708-.079.546-.573.929-1.133.848-.546-.079-.926-.585-.848-1.132.179-1.24.875-2.36 1.912-3.072 1.048-.719 2.322-.955 3.58-.671 1.653.378 2.966 1.69 3.343 3.343.45 2.004-.438 4.006-2.21 4.987-.736.405-1.175 1.072-1.175 1.785v.77c0 .552-.447 1-1 1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 25,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a667b19748c7dd5008a55c16db8b1f31.svg";
export { ForwardRef as ReactComponent };